import { useContext, useState } from 'react';
import { ActionModal } from '../../../../../../components/Modal';
import React from 'react';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import HandlingUnitInfoPane from '../Panes/HandlingUnitInfoPane';
import { HandlingUnit } from '../../../../../../../types/handling_unit/handlingUnit';
import { CompanyContext } from '../../../../../../../context/CompanyContext';
import { Button, CancelButton } from '../../../../../../components/Button';
import useMutation from '../../../../../../../hooks/useMutation';
import {
  CreateHandlingUnitResponse,
  CreateHandlingUnitVariables,
  HandlingUnitMutations,
} from '../../../../../../../graphql/handlingUnit.graphql';
import { HandlingUnitContext } from '../../../../../../../context/HandlingUnitContext';
import { useToast } from '../../../../../../../providers/ToastProvider';
import { ToastType } from '../../../../../../components/Toast';
import { HandlingUnitInput } from '../../../../../../../types/handling_unit/handlingUnit.input';

interface CreateHandlingUnitModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  pmdId?: string;
}

export default function CreateHandlingUnitModal({ open, setOpen, pmdId }: CreateHandlingUnitModalProps) {
  const { showToast } = useToast();

  const { handlingUnits, setHandlingUnits } = useContext(HandlingUnitContext);
  const { currentCompany } = useContext(CompanyContext);

  const [input, setInput] = useState<HandlingUnitInput>(
    new HandlingUnitInput({ companyId: currentCompany.id, productMasterDataId: pmdId }),
  );

  const handleActionCompleted = (hu: HandlingUnit) => {
    setHandlingUnits(new Map(handlingUnits.set(hu.id, hu)));
    setOpen(false);
  };

  const [create, { loading }] = useMutation<CreateHandlingUnitResponse, CreateHandlingUnitVariables>(
    HandlingUnitMutations.create,
    {
      variables: { handlingUnits: [input.forCreate()] },
      onCompleted: response => {
        handleActionCompleted(response.createHandlingUnit[0]);
        showToast({
          type: ToastType.success,
          title: t(TranslationKey.handlingUnitCreatedSuccessfullyToastTitle).singular.upper,
        });
      },
    },
  );

  const footer = (
    <div className='flex justify-end gap-2'>
      <CancelButton onClick={() => setOpen(false)} disabled={loading} />
      <Button
        onClick={() => create()}
        text={t(TranslationKey.create).singular.upper}
        loading={loading}
        disabled={!input.validate() || !input.hasChanges(undefined)}
      />
    </div>
  );

  return (
    <ActionModal
      title={t(TranslationKey.handlingUnitCreate).singular.upper}
      open={open}
      setOpen={setOpen}
      footer={footer}
    >
      <HandlingUnitInfoPane input={input} setInput={setInput} />
    </ActionModal>
  );
}
